import { render } from "./Page9.vue?vue&type=template&id=c7164410&scoped=true"
import script from "./Page9.vue?vue&type=script&lang=js"
export * from "./Page9.vue?vue&type=script&lang=js"

import "./Page9.vue?vue&type=style&index=0&id=c7164410&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7164410"]])

export default __exports__